import { render, staticRenderFns } from "./SocialConnections.vue?vue&type=template&id=043b5a02&scoped=true&"
import script from "./SocialConnections.vue?vue&type=script&lang=ts&"
export * from "./SocialConnections.vue?vue&type=script&lang=ts&"
import style0 from "./SocialConnections.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SocialConnections.vue?vue&type=style&index=1&id=043b5a02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043b5a02",
  null
  
)

export default component.exports